import { DocumentNode, useQuery } from '@apollo/client';
import { useMemo } from 'react';

import { getPaginatedNodes } from './utils';
import { graphql } from '../gql';

// Define the GraphQL query
export const GET_CATEGORIES_FOR_NOTE: DocumentNode = graphql(`
  query getCategoriesForNote {
    claimNoteCategories {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          value
          label
          selected
        }
      }
    }
  }
`);

export function useGetCategoriesForNote() {
  const { loading, error, data } = useQuery(GET_CATEGORIES_FOR_NOTE);

  const { categories, hasCategories } = useMemo(() => {
    return {
      categories: getPaginatedNodes(data?.claimNoteCategories),
      hasCategories: (data?.claimNoteCategories?.edges?.length ?? 0) > 0,
    };
  }, [data]);

  return {
    loading,
    error,
    data,
    categories,
    hasCategories,
  };
}
